module.exports = __webpack_public_path__ + "img/svg/no-competitions.1a93eaf608f27e84c9d6c705bd8b1f84.svg";